import { css } from 'linaria';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
import classNames from 'classnames';
const trendingTag = "t1uit59l";
export const TrendingTag = ({
  children
}) => <div className={classNames(buttonReset, tagBase, trendingTag)}>
    {children}
  </div>;

require("./tag-trending.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-trending.js");